import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Switch, Button, Space } from 'antd';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';
import {
  createRbacRole,
  updateRbacRole
} from '../../redux/actions/rbacActions';

const RoleForm = ({ onCancel }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { editing, rolesLoading } = useSelector(state => state.rbac);

  useEffect(() => {
    if (editing) {
      form.setFieldsValue({
        role_name: editing.role_name,
        enable: editing.enable === 1,
        status: editing.status === 1,
      });
    } else {
      form.resetFields();
    }
  }, [editing, form]);

  const handleSubmit = (values) => {
    const formData = {
      role_name: values.role_name,
      enable: values.enable ? 1 : 0,
      status: values.status ? 1 : 0,
    };

    if (editing) {
      dispatch(updateRbacRole(editing.id, formData));
    } else {
      dispatch(createRbacRole(formData));
    }
    
    onCancel();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        enable: true,
        status: true,
      }}
    >
      <Form.Item
        label="Role Name"
        name="role_name"
        rules={[
          { required: true, message: 'Please enter role name' },
          { min: 2, message: 'Role name must be at least 2 characters' },
          { max: 100, message: 'Role name must not exceed 100 characters' }
        ]}
      >
        <Input placeholder="e.g., Data Analyst, Operator Manager" size="large" />
      </Form.Item>

      <Form.Item
        label="Enable"
        name="enable"
        valuePropName="checked"
        extra="When disabled, this role cannot be assigned to users"
      >
        <Switch checkedChildren="Enabled" unCheckedChildren="Disabled" />
      </Form.Item>

      <Form.Item
        label="Status"
        name="status"
        valuePropName="checked"
        extra="Active status indicates this role is currently in use"
      >
        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
      </Form.Item>

      <Form.Item style={{ marginBottom: 0, marginTop: '2rem' }}>
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={onCancel} icon={<CloseOutlined />}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={rolesLoading}
            icon={<SaveOutlined />}
          >
            {editing ? 'Update Role' : 'Create Role'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default RoleForm;
